<template>
    <select-field :value="value"
                  :options="techRooms"
                  class="tech-rooms-field"
                  value-key="id"
                  label-key="name"
                  :label="label"
                  :name="name"
                  :required="required"
                  :disabled="disabled"
                  :errors="errors"
                  :independent="independent"
                  :placeholder="placeholder"
                  :readonly="readonly"
                  size="mini"
                  @change="$emit('change', $event)">
        <template #prefix>
            <div v-if="value" 
                 class="wh-full f-y-center _ml-0.3">
                <span class="wh-0.75 rounded-sm"
                      :style="{ backgroundColor: getTechRoomColor(value) }" />
            </div>
        </template>
        <template #option="{ option }">
            <div class="space-x-0.5 f-y-center">
                <span class="wh-0.75 rounded-sm"
                      :style="{ backgroundColor: getTechRoomColor(option) }" />
                <span class="fs-0.75">{{ getTechRoomName(option) }}</span>
            </div>
        </template>
    </select-field>
</template>

<script>
import { resourceable } from '@/store/connectors';

import { injectCommonFieldProps } from '@/utils/ui';

import { getTechRoomColor, getTechRoomName } from '@/models/techRooms';

import SelectField from '@/components/fields/SelectField';

export default {
  components: {
    SelectField
  },

  mixins: [
    resourceable({ on: 'techRooms', name: 'techRooms', mounted: true })
  ],

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    ...injectCommonFieldProps(),

    value: { type: [Object, Array, String], default: null }
  },

  data() {
    return {
      getTechRoomColor, 
      getTechRoomName
    }
  }
}
</script>
